<template>
  <div class=" mb-5 px-5">
    <v-text-field
      v-if="enableSearch"
      v-model="searchKeyWord"
      outlined
      hide-details
      class="mb-2"
      :label="label"
    ></v-text-field>
    <vue-horizontal
      ref="horizontal"
      scroll
      :button="false"
      :class="horizontalClass"
      @scroll="handleScroll"
    >
      <section
        v-show="selectedList.length>0"
        class="selected-list mr-5"
      >
        <user-item
          v-for="(userData, index) in selectedList"
          :key="userData.id"
          :user-data="userData"
          @click.native="handleRemove(userData, index)"
        ></user-item>
      </section>
      <section
        class="user-list pr-5"
      >
        <user-item
          v-for="(userData, index) in internalList"
          :key="userData.id"
          :user-data="userData"
          @click.native="handleClick(userData, index)"
        ></user-item>
        <section v-if="internalList.length==0">
          No data
        </section>
      </section>
    </vue-horizontal>
    <div
      v-if="showErrorMessage"
      class="error-message"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs, nextTick, watch, onMounted, getCurrentInstance, computed } from 'vue'
import VueHorizontal from 'vue-horizontal'
import UserItem from './UserItem'
import InputContainer from '../CRUD/InputContainer.vue'

const horizontalClass = ref('horizontal')

function handleScroll(e) {
  console.log('e', e)
}

onMounted(() => {
})

const props = defineProps({
  enableSearch: {
    type: Boolean,
    default: false,
  },
  limit: {
    type: Number,
    default: 1,
  },
  label: {
    type: String,
    default: 'Search',
  },
  userList: {
    type: Array,
    default() {
      return []
    },
  },

  // enableSelected: {
  //   type: Boolean,
  //   default: false,
  // },
  defaultSelectedList: {
    type: Array,
    default() {
      return []
    },
  },
  errorMessage: {
    type: String,
    default: 'Please select a user',
  },
  rule: {
    type: Function,
    default() {
      return (selectedList, internalList) => true
    },
  },
  searchCallback: {
    type: Function,
    default: null,
  },
})
const { userList, limit,
  // enableSelected,
  defaultSelectedList, errorMessage,
  rule,
  searchCallback,
} = toRefs(props)
const searchKeyWord = ref('')

const horizontal = ref(null)
const internalList = ref([])
internalList.value = [...userList.value]
const selectedList = ref([])
const backupList = ref([])
const backupFullList = ref([])
const showErrorMessage = ref(false)

const isMobile = computed(() => {
  if (horizontal.value) {
    return horizontal.value.$vuetify.breakpoint.mdAndDown
  }

  return false
})

watch(isMobile, newValue => {
  console.log('isMobile', newValue)
  if (newValue) {
    horizontalClass.value = 'horizontal-mobile'
  } else {
    horizontalClass.value = 'horizontal'
  }
}, { deep: true })

function validate() {
  const checking = rule.value
  const result = checking(selectedList.value, internalList.value)
  showErrorMessage.value = !result

  return result
}
function resetValidation() {
  showErrorMessage.value = false
}

watch(defaultSelectedList, newValue => {
  console.log('defaultSelectedList updated', defaultSelectedList.value)

  nextTick(() => {
    selectedList.value = [...newValue]
  })
}, { deep: true })

watch(userList, newValue => {
  console.log('userList updated', userList.value)

  nextTick(() => {
    internalList.value = [...newValue]
  })
}, { deep: true })

watch(searchKeyWord, (newValue, oldValue) => {
  if (backupFullList.value.length === 0) {
    backupFullList.value = [...internalList.value]
  }

  // filter result

  // filter list by input
  if (newValue) {
    const searchValue = newValue.toLowerCase()
    internalList.value = backupFullList.value.filter(record => {
      // console.log('record', record)
      if (record.fullName) {
        if (record.fullName.toLowerCase().includes(searchValue)) {
          return true
        }
      }

      // console.log('record.mobileNo.toLowerCase().includes(searchValue)', record.mobileNo.toLowerCase().includes(searchValue))
      if (record.userNo.toLowerCase().includes(searchValue) || record.mobileNo.toLowerCase().includes(searchValue)) {
        return true
      }

      if (searchCallback.value) {
        return searchCallback.value(record, searchValue)
      }

      return false
    })
  }
  if (newValue.length === 0) {
    internalList.value = [...backupFullList.value]
    backupFullList.value = []
  }
})

defineExpose({ selectedList, internalList, validate, resetValidation })

function sortById(elem1, elem2) {
  if (elem1.id < elem2.id) {
    return -1
  } if (elem1.id > elem2.id) {
    return 1
  }

  return 0
}
const emit = defineEmits(['click', 'remove'])
function handleRemove(userData, index) {
  console.log('remove userData from selected', userData, index)
  const arr = selectedList.value
  if (arr.length > 0) {
    arr.splice(index, 1)
  }

  // Prevent missing record after filter and remove the user
  if (searchKeyWord.value) {
    backupFullList.value.push(userData)
  }

  internalList.value.push(userData)

  // arr.sort(sortById)
  internalList.value.sort(sortById)

  // nextTick(() => {
  //   horizontal.value.scrollToLeft(0)
  // })
  emit('remove', userData)
}

// function addItemToSelected(item) {
//   const arr = internalList.value
//   if (arr.length > 0) {
//     arr.splice(index, 1)
//   }
//   selectedList.value.push(item)
//   arr.sort(sortById)

//   // selectedList.value.sort(sortById)
//   nextTick(() => {
//     horizontal.value.scrollToLeft(0)
//   })
// }

function handleClick(userData, index) {
  console.log('add userData to selected', userData, index)

  function addItemToSelected(item) {
    const arr = internalList.value
    const backArr = backupFullList.value
    console.log('internalList.value', internalList.value)
    console.log('backArr.value', backArr.value)
    if (arr.length > 0) {
      arr.splice(index, 1)
    }
    if (backArr.length > 0) {
      const backArrIndex = backArr.findIndex(record => record.id === userData.id)
      backArr.splice(backArrIndex, 1)
    }
    selectedList.value.push(item)
    arr.sort(sortById)
    backArr.sort(sortById)

    // selectedList.value.sort(sortById)
    nextTick(() => {
      horizontal.value.scrollToLeft(0)
    })

    emit('click', item)

    const result = validate()
    console.log('handleClick validate result', result)
    if (validate()) {
      resetValidation()
    }
  }

  if (selectedList.value.length >= limit.value) {
    console.log('selectedList.value.length', selectedList.value.length)

    if (limit.value === 1) {
      console.log('limit.value', limit.value)
      const arr = selectedList.value
      if (arr.length > 0) {
        const deletedElement = arr.splice(0, 1)[0]
        console.log('deletedElement', deletedElement)

        internalList.value.push(deletedElement)
      }
      addItemToSelected(userData)

      console.log('selectedList', selectedList)
    }

    return
  }
  addItemToSelected(userData)
}
</script>
<style scoped>
.selected-list{
  border-radius: 5px;
  border-style: solid;
  border-color: #566369;
}
.ma-2 {
  margin: 16px;
  display: inline-block !important;
  white-space: nowrap;
}
.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal-mobile >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 10px;
  width: 16px;
  background: transparent;
}

.horizontal >>> .v-hl-container::-webkit-scrollbar-track {
  /* background: black; */
  border-radius: 4px;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.horizontal >>> .v-hl-container::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
}
.error-message{
  color:red;
}
</style>
